import { render, staticRenderFns } from "./CongratulationCardH2h.vue?vue&type=template&id=6b66436e&scoped=true&"
import script from "./CongratulationCardH2h.vue?vue&type=script&lang=js&"
export * from "./CongratulationCardH2h.vue?vue&type=script&lang=js&"
import style0 from "./CongratulationCardH2h.vue?vue&type=style&index=0&id=6b66436e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b66436e",
  null
  
)

export default component.exports